var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('div',{attrs:{"id":"loading-panel"}},[_c('img',{staticClass:"logo",attrs:{"src":require("../../static/img/loading.png"),"alt":""}}),_vm._v(" "),_c('p',[_c('span',{style:({width:_vm.percent})})]),_vm._v(" "),_c('h2',[_c('strong',[_vm._v(_vm._s(_vm.percent))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ab208a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading.vue
// module id = null
// module chunks = 